// Display helpers: rupees, dates, file sizes
export const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const dateText = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

// 512 B, 3.4 KB, 10.25 MB, 2 GB (whole gigabytes without decimals)
export const bytes = (n) => {
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(2)} MB`;
  const gb = n / 1024 ** 3;
  return `${Number.isInteger(gb) ? gb : gb.toFixed(2)} GB`;
};

// How the three account roles are shown in the panel
export const ROLE_LABELS = { superadmin: "Super Admin", subadmin: "Sub Admin", storeadmin: "Store owner", staff: "Staff", support: "Support Admin" };
